export default __webpack_public_path__ + "static/media/call-to-action-left.e9c12c4d.png";